__turbopack_context__.v({
  "brief": "authorisationItem-module-scss-module__6A3xOa__brief",
  "container": "authorisationItem-module-scss-module__6A3xOa__container",
  "container-selected": "authorisationItem-module-scss-module__6A3xOa__container-selected",
  "detail": "authorisationItem-module-scss-module__6A3xOa__detail",
  "detail-container": "authorisationItem-module-scss-module__6A3xOa__detail-container",
  "detail-icon": "authorisationItem-module-scss-module__6A3xOa__detail-icon",
  "separator": "authorisationItem-module-scss-module__6A3xOa__separator",
  "subgroup": "authorisationItem-module-scss-module__6A3xOa__subgroup",
  "type": "authorisationItem-module-scss-module__6A3xOa__type",
});
